export const HostGameBreakdownSteps = {
  first: 1022,
  second: 968,
  third: 840,
  forth: 620,
};
